import { ContentWrapper } from '../../..'
import { TopBarSubMenuProps } from '../../types'
import { SubItemLink } from '../links'

export interface MobileSubMenuItemProps {
  subMenu: TopBarSubMenuProps[]
  handleMobileMenuClose: () => void
}

export const MobileSubMenuItem = ({
  subMenu,
  handleMobileMenuClose
}: MobileSubMenuItemProps) => {
  return (
    <>
      {subMenu.map((sublink: TopBarSubMenuProps) => {
        const { isHidden, ...link } = sublink
        return (
          <ContentWrapper key={link.key} showContent={isHidden !== true}>
            <SubItemLink onClick={handleMobileMenuClose} link={link} />
          </ContentWrapper>
        )
      })}
    </>
  )
}
